import script from "./SliderItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./SliderItem.vue?vue&type=script&setup=true&lang=ts"

import "./SliderItem.vue?vue&type=style&index=0&id=36f5f364&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36f5f364"]])

export default __exports__